<div class="sceau-header">
  <div class="sceau-header-row">
    <button type="button" class="sceau-toggle" [cSidebarToggle]="sidebarId" (click)="toggleSidebar()">
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button>

    <!-- ── Recherche / sélection mairie ── -->
    <div class="sceau-mairie position-relative">
      <svg cIcon name="cilLocationPin" size="sm" class="sceau-mairie-icon"></svg>
      <input
        type="text"
        class="sceau-mairie-input"
        [(ngModel)]="mairie_search"
        (input)="on_mairie_search()"
        (focus)="show_mairie_dropdown = true"
        (blur)="on_blur_mairie()"
        [placeholder]="id_mairie ? get_mairie_label() : 'Toutes les mairies'"
      />
      <span *ngIf="id_mairie" class="sceau-mairie-clear" (mousedown)="select_mairie('', $event)">×</span>

      <ul class="sceau-mairie-dropdown" *ngIf="show_mairie_dropdown && mairies_filtrees.length > 0">
        <li (mousedown)="select_mairie('', $event)" class="sceau-mairie-item sceau-mairie-all">
          Toutes les mairies
        </li>
        <li *ngFor="let m of mairies_filtrees"
            (mousedown)="select_mairie(m.id_mairie, $event)"
            class="sceau-mairie-item"
            [class.active]="m.id_mairie == id_mairie">
          {{ m.nom }}
        </li>
      </ul>
    </div>

    <div class="sceau-spacer"></div>

    <div class="sceau-version d-none d-md-block" (click)="checkForUpdates()">{{ api.version.id }}</div>

    <!-- ── Cloche Réclamations ── -->
    <c-dropdown *ngIf="api.can('/home/reclamation')" alignment="end" variant="nav-item">
      <button cButton color="transparent" [caret]="false" cDropdownToggle class="sceau-icon-btn">
        <svg cIcon name="cilBell" size="lg"></svg>
        <c-badge *ngIf="pendingReclamationCount > 0"
          class="position-absolute top-0 start-100 translate-middle"
          color="primary" shape="rounded-pill"
          style="font-size:0.62rem;min-width:17px;min-height:17px;display:flex;align-items:center;justify-content:center;">
          {{ pendingReclamationCount > 99 ? '99+' : pendingReclamationCount }}
        </c-badge>
      </button>
      <div cDropdownMenu class="sceau-reclamation-menu">
        <div class="d-flex align-items-center justify-content-between sceau-reclamation-header px-3 py-2">
          <div class="d-flex align-items-center gap-2">
            <svg cIcon name="cilBell" size="sm"></svg>
            <span class="fw-bold">Réclamations en attente</span>
          </div>
          <span class="badge rounded-pill" style="background: var(--sceau-gold); color:#2b2211;">{{ pendingReclamationCount }}</span>
        </div>
        <div class="sceau-reclamation-list">
          <ng-container *ngIf="pendingReclamations.length > 0; else noRec">
            <a *ngFor="let rec of pendingReclamations.slice(0, 6)"
              [routerLink]="['/home/reclamation']" cDropdownItem
              class="sceau-reclamation-item text-decoration-none">
              <div class="d-flex align-items-center justify-content-between mb-1">
                <span class="fw-semibold text-truncate">{{ rec.motif || rec.titre || 'Sans motif' }}</span>
                <span class="badge rounded-pill ms-2 flex-shrink-0" style="background: rgba(224,184,97,0.18); color:#a97f2f; font-size:0.65rem;">
                  {{ (rec.cible_reclamation || 'mairie') | titlecase }}
                </span>
              </div>
              <small class="text-muted text-wrap d-block">
                {{ rec.contenu?.length > 80 ? (rec.contenu | slice:0:80) + '...' : rec.contenu }}
              </small>
              <small class="text-end text-muted mt-1 d-block">{{ rec.created_at | date:'dd/MM/yyyy HH:mm' }}</small>
            </a>
          </ng-container>
          <ng-template #noRec>
            <div class="text-center py-4">
              <svg cIcon name="cilCheck" size="xl"></svg>
              <p class="mb-0 text-muted small mt-2">Aucune réclamation en attente</p>
            </div>
          </ng-template>
        </div>
        <div class="sceau-reclamation-footer px-3 py-2 text-center">
          <a [routerLink]="['/home/reclamation']" class="btn btn-sm w-100 fw-semibold" style="background: var(--sceau-gold); color:#2b2211;">
            Voir toutes les réclamations →
          </a>
        </div>
      </div>
    </c-dropdown>

    <!-- ── Utilisateur ── -->
    <c-dropdown alignment="end" variant="nav-item">
      <button cButton color="" [caret]="false" cDropdownToggle class="sceau-user-btn">
        <div class="sceau-avatar-sm">{{ (api.infos?.agent?.prenom || '?').substring(0, 2) }}</div>
        <span class="sceau-user-text d-none d-lg-flex">
          <span class="u-name">{{ get_titre().titre }}</span>
          <span class="u-role">{{ get_titre().description }}</span>
        </span>
      </button>
      <ul cDropdownMenu class="pt-0 pr-5 w-auto">
        <li><a [routerLink]="['/home/profil']" cDropdownItem><svg cIcon class="me-2" name="cilUser"></svg>Profile</a></li>
        <li><a (click)="api.deconnexion()" cDropdownItem><svg cIcon class="me-2" name="cilLockLocked"></svg>Déconnexion</a></li>
      </ul>
    </c-dropdown>
  </div>
</div>
